"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _components = _interopRequireDefault(require("../../../styles/components"));

var _PrimaryControls = _interopRequireDefault(require("./PrimaryControls"));

var _ProgressControls = _interopRequireDefault(require("./ProgressControls"));

var _voicebase = _interopRequireDefault(require("../../../assets/voicebase.svg"));

var _Panel = _interopRequireDefault(require("../../../common/Panel/Panel"));

var _Switch = _interopRequireDefault(require("../../../common/Switch"));

var _connectToMedia = _interopRequireDefault(require("../../Media/connectToMedia"));

var _ToolTip = _interopRequireDefault(require("../../../common/ToolTip"));

var _VoicebaseReactPlayerContext = _interopRequireDefault(require("../../../VoicebaseReactPlayerContext"));

var _exportTranscriptToText = require("../../../utilities/exportTranscriptToText");

var _icons = require("../../../assets/icons");

var _lodash = _interopRequireDefault(require("lodash"));

var _package = _interopRequireDefault(require("../../../../package.json"));

var _utility = require("../../../utilities/analytics-parser/utility");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FLAG_ACTION_MAP = {
  DELETE: "delete",
  REDACT: "redact"
};
var MediaId = {
  Keywords: "Key Words",
  Phrase: "Phrase Spotting",
  Noun: "Verbs/Noun",
  Sentiment: "Sentiment",
  Entities: "Entities"
};

var getSentimentButtonColor = function getSentimentButtonColor(isSentimentAnalyzerOn) {
  return isSentimentAnalyzerOn ? "#339EEC" : "#9E9E9E";
};

function preventDefault(e) {
  e.preventDefault();
}

var Index = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(Index, _React$PureComponent);

  function Index(props) {
    var _this;

    _this = _React$PureComponent.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "onVisibleChangeForPCITooltip", function (isPCIFlagTooltipVisible) {
      _this.setState({
        isPCIFlagTooltipVisible: isPCIFlagTooltipVisible
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onVisibleChangeForMoreTooltip", function (isMoreTooltipVisible) {
      _this.setState({
        isMoreTooltipVisible: isMoreTooltipVisible
      });

      if (!isMoreTooltipVisible) {
        _this.setState({
          isCopyId: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "flagCall", function () {
      var handlePCIFlagClick = _this.props.handlePCIFlagClick;

      _this.setState({
        isPCIFlagTooltipVisible: false
      });

      if (handlePCIFlagClick) {
        handlePCIFlagClick();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "changeSentimentAnalyzer", function (event) {
      var onChangeSentimentAnalyzer = _this.props.onChangeSentimentAnalyzer;
      onChangeSentimentAnalyzer(event);

      _this.setState({
        isSentimentAnalyzerSwitchOn: event
      });
    });

    _defineProperty(_assertThisInitialized(_this), "changeMedia", function (event, name, index) {
      var _this$props = _this.props,
          onChangeSentimentAnalyzer = _this$props.onChangeSentimentAnalyzer,
          onChangeKeywordAnalyzer = _this$props.onChangeKeywordAnalyzer,
          onChangePhraseSupportingAnalyzer = _this$props.onChangePhraseSupportingAnalyzer,
          onChangeVerbNounAnalyzer = _this$props.onChangeVerbNounAnalyzer,
          onChangeEntitiesAnalyzer = _this$props.onChangeEntitiesAnalyzer;
      var media = _this.state.MediaIdItem;
      media[index].value = event;

      _this.setState({
        MediaIdItem: [].concat(media)
      });

      if (name === MediaId.Keywords) {
        onChangeKeywordAnalyzer(event);
      } else if (name === MediaId.Phrase) {
        onChangePhraseSupportingAnalyzer(event);
      } else if (name === MediaId.Noun) {
        onChangeVerbNounAnalyzer(event);
      } else if (name === MediaId.Sentiment) {
        onChangeSentimentAnalyzer(event);
      } else {
        onChangeEntitiesAnalyzer(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onClickCopyId", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
        var mediaId;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                mediaId = _this.props.mediaId;

                _this.setState({
                  isCopyId: true
                });

                _context.next = 4;
                return navigator.clipboard.writeText(mediaId);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "downloadMediaFile", function (isHostedApp, mediaDownloadResponse) {
      var _this$props2 = _this.props,
          mediaId = _this$props2.mediaId,
          mediaUrl = _this$props2.mediaUrl,
          metaData = _this$props2.metaData;

      _this.setState({
        mediaDownloadLoading: true
      });

      var title = mediaId;
      var contentType = metaData === null || metaData === void 0 ? void 0 : metaData.contentType;
      (0, _utility.downloadMedia)(mediaUrl, title, contentType, function (resp) {
        _this.setState({
          mediaDownloadLoading: false
        });

        if (!resp.success) {
          if (!isHostedApp && mediaDownloadResponse) {
            mediaDownloadResponse(resp);
            return;
          }

          _this.props.showToast("An error occurred while trying to download your file. Please reopen the media and try downloading again.", "error");

          return;
        }

        if (!isHostedApp && mediaDownloadResponse) {
          mediaDownloadResponse(resp);
          return;
        }

        _this.props.showToast("File downloaded successfully", "success");
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getFlagActionTextForRedact", function () {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", null, "Please confirm you\u2019d like to mark this"), " ", /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("span", null, "call as having PCI present."), " ", /*#__PURE__*/_react["default"].createElement("br", null), " ", /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("span", null, "This call will immediately be reprocessed"), " ", /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("span", null, "to remove all numbers and reviewed"), " ", /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("span", null, "by your account admin."), " ", /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("span", null, "NOTE: It might take about 10 minutes"), " ", /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("span", null, "or more for the system to reflect"), " ", /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("span", null, "the changes on the media file!"), " ", /*#__PURE__*/_react["default"].createElement("br", null), " ", /*#__PURE__*/_react["default"].createElement("br", null));
    });

    _defineProperty(_assertThisInitialized(_this), "getFlagActionTextForDelete", function () {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", null, "Please confirm you\u2019d like to mark this"), " ", /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("span", null, "call as having PCI present."), " ", /*#__PURE__*/_react["default"].createElement("br", null), " ", /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("span", null, "This call will immediately be deleted and"), " ", /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("span", null, "reviewed by the account admin."), " ", /*#__PURE__*/_react["default"].createElement("br", null), " ", /*#__PURE__*/_react["default"].createElement("br", null));
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var _this$props3 = _this.props,
          onChangeSentimentAnalyzer = _this$props3.onChangeSentimentAnalyzer,
          onChangeKeywordAnalyzer = _this$props3.onChangeKeywordAnalyzer,
          onChangePhraseSupportingAnalyzer = _this$props3.onChangePhraseSupportingAnalyzer,
          onChangeVerbNounAnalyzer = _this$props3.onChangeVerbNounAnalyzer,
          onChangeEntitiesAnalyzer = _this$props3.onChangeEntitiesAnalyzer;
      onChangeKeywordAnalyzer(true);
      onChangePhraseSupportingAnalyzer(true);
      onChangeVerbNounAnalyzer(true);
      onChangeSentimentAnalyzer(true);
      onChangeEntitiesAnalyzer(true);
    });

    _this.state = {
      isPCIFlagTooltipVisible: false,
      isMoreTooltipVisible: false,
      isKeywordSwitchOn: false,
      isPhraseSwitchOn: false,
      isVerbSwitchOn: false,
      isSentimentAnalyzerSwitchOn: false,
      isCopyId: false,
      MediaIdItem: [{
        name: MediaId.Keywords,
        value: true
      }, {
        name: MediaId.Phrase,
        value: true
      }, {
        name: MediaId.Noun,
        value: true
      }, {
        name: MediaId.Sentiment,
        value: true
      }, {
        name: MediaId.Entities,
        value: true
      }],
      mediaDownloadLoading: false
    };
    return _this;
  }

  var _proto = Index.prototype;

  _proto.setSentimentAnalyzer = function setSentimentAnalyzer(speakerSentiments) {
    var isSentimentAnalyzerSwitchOn = this.state.isSentimentAnalyzerSwitchOn;
    return /*#__PURE__*/_react["default"].createElement(_components["default"].TooltipContent, null, /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        opacity: "50%"
      }
    }, "SENTIMENT ANALYZER"), " ", /*#__PURE__*/_react["default"].createElement("br", null), speakerSentiments && speakerSentiments.length > 0 ? /*#__PURE__*/_react["default"].createElement(_components["default"].TooltipContent, null, /*#__PURE__*/_react["default"].createElement(_Switch["default"], {
      onChange: this.changeSentimentAnalyzer,
      onClick: this.changeSentimentAnalyzer,
      disabled: false,
      checked: isSentimentAnalyzerSwitchOn
    }), /*#__PURE__*/_react["default"].createElement("span", null, " ", isSentimentAnalyzerSwitchOn ? "on" : "off")) : /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        opacity: "50%"
      }
    }, " No sentiment data available! "));
  };

  _proto.copyIcon = function copyIcon() {
    return this.state.isCopyId ? /*#__PURE__*/_react["default"].createElement("svg", {
      width: "20",
      height: "21",
      viewBox: "0 0 20 21",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M16.875 6.04541L8.125 14.795L3.75 10.4204",
      stroke: "white",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })) : /*#__PURE__*/_react["default"].createElement("svg", {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      style: {
        cursor: "pointer"
      }
    }, /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.5"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M16.8746 14.3746V3.12451H5.62402",
      stroke: "white",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M14.3745 5.62451H3.12402V16.8745H14.3745V5.62451Z",
      stroke: "white",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })));
  };

  _proto.setMoreDetails = function setMoreDetails() {
    var _this2 = this;

    var _this$context = this.context,
        _this$context$isHoste = _this$context.isHostedApp,
        isHostedApp = _this$context$isHoste === void 0 ? false : _this$context$isHoste,
        _this$context$exportT = _this$context.exportTranscript,
        exportTranscript = _this$context$exportT === void 0 ? function () {} : _this$context$exportT,
        mediaDownloadResponse = _this$context.mediaDownloadResponse;
    var _this$props4 = this.props,
        metaData = _this$props4.metaData,
        isChatTextMedia = _this$props4.isChatTextMedia;
    var isSentimentAnalyzerSwitchOn = this.state.isSentimentAnalyzerSwitchOn;
    return /*#__PURE__*/_react["default"].createElement(_components["default"].TooltipContent, {
      style: {
        textAlign: "left"
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        minWidth: "max-content"
      }
    }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "media-top-text",
      style: {
        display: "inline-flex"
      }
    }, (0, _icons.ExportIcon)(), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        marginLeft: "20px",
        cursor: "pointer"
      },
      className: "export-transcript",
      onClick: _lodash["default"].debounce(function () {
        (0, _exportTranscriptToText.exportTranscriptToText)({
          metaData: metaData,
          exportTranscript: exportTranscript,
          isHostedApp: isHostedApp
        });
      }, 200)
    }, "Export Transcript")), !isChatTextMedia && /*#__PURE__*/_react["default"].createElement("div", {
      className: "media-top-text",
      style: {
        display: "inline-flex"
      }
    }, this.state.mediaDownloadLoading ? (0, _icons.LoadingIcon)() : (0, _icons.DownloadIcon)(), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        marginLeft: "20px",
        cursor: "pointer"
      },
      className: "export-transcript",
      onClick: _lodash["default"].debounce(function () {
        _this2.downloadMediaFile(isHostedApp, mediaDownloadResponse);
      }, 200)
    }, this.state.mediaDownloadLoading ? "Downloading" : "Download Media"))), !isHostedApp && /*#__PURE__*/_react["default"].createElement("div", {
      className: "media-top-text",
      style: {
        display: "inline-flex"
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        marginTop: "5px"
      },
      onClick: function onClick(event) {
        return _this2.onClickCopyId(event);
      }
    }, this.copyIcon()), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        marginLeft: "20px",
        marginTop: "5px",
        cursor: "pointer"
      }
    }, this.state.isCopyId ? /*#__PURE__*/_react["default"].createElement("div", null, "Copied") : /*#__PURE__*/_react["default"].createElement("div", {
      onClick: function onClick(event) {
        return _this2.onClickCopyId(event);
      }
    }, "Copy Media ID")))), /*#__PURE__*/_react["default"].createElement("hr", {
      className: "panel-hr-line"
    }), this.state.MediaIdItem.map(function (media, index) {
      return /*#__PURE__*/_react["default"].createElement(_components["default"].MoreDetailTooltipContent, null, /*#__PURE__*/_react["default"].createElement(_Switch["default"], {
        onChange: function onChange(event) {
          return _this2.changeMedia(event, media.name, index);
        },
        onClick: function onClick(event) {
          return _this2.changeMedia(event, media.name, index);
        },
        disabled: false,
        checked: media.value
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: "media-text"
      }, " ", media.name));
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "media-top-text"
    }, /*#__PURE__*/_react["default"].createElement("hr", {
      className: "panel-hr-line"
    }), /*#__PURE__*/_react["default"].createElement("div", null, "v" + _package["default"].version)));
  };

  _proto.pciFlagCallOverlay = function pciFlagCallOverlay(isPCIFlagEnabled, flagAction) {
    var _this3 = this;

    if (flagAction === void 0) {
      flagAction = FLAG_ACTION_MAP.DELETE;
    }

    return /*#__PURE__*/_react["default"].createElement(_components["default"].TooltipContent, null, flagAction === FLAG_ACTION_MAP.DELETE ? this.getFlagActionTextForDelete() : this.getFlagActionTextForRedact(), /*#__PURE__*/_react["default"].createElement(_components["default"].FlagCallButtonContent, null, /*#__PURE__*/_react["default"].createElement(_components["default"].FlagCallButton, {
      onClick: function onClick() {
        return _this3.flagCall();
      },
      disabled: isPCIFlagEnabled,
      style: isPCIFlagEnabled ? {
        display: "inline-flex",
        cursor: " not-allowed"
      } : {
        display: "inline-flex"
      }
    }, /*#__PURE__*/_react["default"].createElement(_components["default"].FlagCallImage, null, /*#__PURE__*/_react["default"].createElement("svg", {
      width: "21",
      height: "21",
      viewBox: "0 0 21 21",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M3.52759 17.8105V4.68555",
      stroke: "white",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M3.52759 14.061C8.52759 10.311 12.2776 17.811 17.2776 14.061V4.68605C12.2776 8.43605 8.52759 0.936047 3.52759 4.68605",
      stroke: "white",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }))), " ", /*#__PURE__*/_react["default"].createElement(_components["default"].FlagCallText, null, !isPCIFlagEnabled ? "Flag Call" : "Call already flagged"))));
  };

  _proto.render = function render() {
    var _this$props5 = this.props,
        mediaId = _this$props5.mediaId,
        speakerSentiments = _this$props5.speakerSentiments,
        isPCIFlagEnabled = _this$props5.isPCIFlagEnabled,
        showPCIFlag = _this$props5.showPCIFlag,
        flagAction = _this$props5.flagAction,
        handlePCIFlagClick = _this$props5.handlePCIFlagClick,
        isMiniPlayerVisible = _this$props5.isMiniPlayerVisible,
        setClickMinMaxPlayerVisible = _this$props5.setClickMinMaxPlayerVisible,
        metaData = _this$props5.metaData,
        isChatTextMedia = _this$props5.isChatTextMedia;
    var _this$state = this.state,
        isSentimentAnalyzerSwitchOn = _this$state.isSentimentAnalyzerSwitchOn,
        isMoreTooltipVisible = _this$state.isMoreTooltipVisible,
        isPCIFlagTooltipVisible = _this$state.isPCIFlagTooltipVisible;
    var contextData = this.context;
    var _this$context$isHoste2 = this.context.isHostedApp,
        isHostedApp = _this$context$isHoste2 === void 0 ? false : _this$context$isHoste2;
    return /*#__PURE__*/_react["default"].createElement(_Panel["default"], null, /*#__PURE__*/_react["default"].createElement(_components["default"].Controls, null, /*#__PURE__*/_react["default"].createElement(_components["default"].ControlsBar, null, /*#__PURE__*/_react["default"].createElement(_components["default"].ControlsGroup, {
      style: {
        flex: "auto"
      }
    }, /*#__PURE__*/_react["default"].createElement(_PrimaryControls["default"], {
      agentDetail: metaData.detail,
      mediaId: mediaId
    })), showPCIFlag && handlePCIFlagClick && /*#__PURE__*/_react["default"].createElement(_components["default"].ControlsGroup, null, /*#__PURE__*/_react["default"].createElement(_ToolTip["default"], {
      key: "flagCall",
      placement: "bottom",
      trigger: ["click"],
      visible: isPCIFlagTooltipVisible,
      onVisibleChange: this.onVisibleChangeForPCITooltip,
      overlay: /*#__PURE__*/_react["default"].createElement("span", null, this.pciFlagCallOverlay(isPCIFlagEnabled, flagAction))
    }, isPCIFlagEnabled ? /*#__PURE__*/_react["default"].createElement(_components["default"].FlagCallContent, {
      onClick: preventDefault,
      style: {
        alignItems: "center"
      }
    }, /*#__PURE__*/_react["default"].createElement("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M2.5 13.5V3",
      stroke: "#CD4B32",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M2.5 10.4998C6.5 7.49981 9.5 13.4998 13.5 10.4998V2.99981C9.5 5.99981 6.5 -0.000185549 2.5 2.99981",
      fill: "#CD4B32",
      stroke: "#CD4B32",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })), /*#__PURE__*/_react["default"].createElement(_components["default"].ContentTitle, null, "Flag")) : /*#__PURE__*/_react["default"].createElement(_components["default"].FlagCallContent, {
      onClick: preventDefault,
      style: {
        alignItems: "center"
      }
    }, /*#__PURE__*/_react["default"].createElement("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M2.5 13.5V3",
      stroke: "#677791",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M2.5 10.4998C6.5 7.49981 9.5 13.4998 13.5 10.4998V2.99981C9.5 5.99981 6.5 -0.000185549 2.5 2.99981",
      stroke: "#677791",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })), /*#__PURE__*/_react["default"].createElement(_components["default"].ContentTitle, {
      style: {
        color: isPCIFlagTooltipVisible ? "#262D38" : "#677791"
      }
    }, "Flag")))), !isChatTextMedia && !isHostedApp ? /*#__PURE__*/_react["default"].createElement(_components["default"].ControlsGroup, null, /*#__PURE__*/_react["default"].createElement(_components["default"].MinimizeContent, {
      onClick: function onClick() {
        return setClickMinMaxPlayerVisible();
      },
      style: {
        alignItems: "center"
      }
    }, /*#__PURE__*/_react["default"].createElement("svg", {
      width: "21",
      height: "20",
      viewBox: "0 0 21 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M13.7598 6.875L5.00977 15.625",
      stroke: "#677791",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M5.00977 8.125V15.625H12.5098",
      stroke: "#677791",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M16.2598 3.125H3.75977",
      stroke: "#677791",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })), /*#__PURE__*/_react["default"].createElement(_components["default"].ContentTitle, null, "Minimize"))) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null), /*#__PURE__*/_react["default"].createElement(_components["default"].ControlsGroup, null, /*#__PURE__*/_react["default"].createElement(_ToolTip["default"], {
      style: {
        textAlign: "center"
      },
      placement: "bottom",
      trigger: ["click"],
      onVisibleChange: this.onVisibleChangeForMoreTooltip,
      overlay: /*#__PURE__*/_react["default"].createElement("span", null, this.setMoreDetails())
    }, /*#__PURE__*/_react["default"].createElement(_components["default"].SentimentButton, null, /*#__PURE__*/_react["default"].createElement(_components["default"].ContentTitle, {
      style: {
        marginLeft: "0",
        display: "flex",
        color: isMoreTooltipVisible ? "#262D38" : "#677791"
      }
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: "dot-content"
    }, "..."), "More")))))));
  };

  return Index;
}(_react["default"].PureComponent);

_defineProperty(Index, "contextType", _VoicebaseReactPlayerContext["default"]);

var _default = (0, _connectToMedia["default"])()(Index);

exports["default"] = _default;